import axios from 'axios';
import { camelToSnake, snakeToCamel } from './caseUtils';

declare module 'axios' {
  interface AxiosRequestConfig {
    disableParsing?: boolean;
  }
}

export function configAxios() {
  axios.interceptors.request.use((config) => {
    if (
      config.disableParsing ||
      config.headers['Content-Type'] === 'multipart/form-data'
    ) {
      return config;
    }
    return {
      ...config,
      data: config.data ? camelToSnake(config.data) : config.data,
      params: config.params ? camelToSnake(config.params) : config.params,
    };
  });

  axios.interceptors.response.use((response) => {
    if (response.config.disableParsing) {
      return response;
    }
    return {
      ...response,
      data: response.data ? snakeToCamel(response.data) : response.data,
    };
  });
}
